import styled from 'styled-components';

import { WHITE, BLACK, PAGE_WIDTH } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

const CELL_SIZE = PAGE_WIDTH / 3 - 10;
const MOBILE_CELL_SIZE = 250;

export const Section = styled.section`
  background-color: ${WHITE};
  max-width: ${PAGE_WIDTH}px;
  width: 100%;
  margin: 0 auto 80px;
  overflow: hidden;
`;
export const Title = styled.h5`
  background: ${WHITE};
  position: relative;
  text-transform: uppercase;
  margin: 40px 0 60px;
  letter-spacing: 0.1em;
  text-align: center;
  color: ${BLACK};

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BLACK};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    margin-top: 0px;
    margin-bottom: 75px;
  `};
`;

export const GridWrapper = styled.div`
  display: none;
  grid-template-columns: repeat(auto-fill, minmax(${CELL_SIZE}px, 1fr));
  justify-content: center;

  ${media.tabletL`
    display: grid;
  `};
`;

export const SliderWrapper = styled.div`
  display: block;
  width: ${MOBILE_CELL_SIZE}px;
  height: ${MOBILE_CELL_SIZE}px;

  & > div > div {
    width: ${MOBILE_CELL_SIZE}px;
    overflow: visible !important;
  }

  ${media.tabletL`
    display: none;
  `};
`;

export const InstructorCell = styled.div`
  padding: 3em 1em;
  display: flex;
  flex-direction: column;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(${({ url }) => url});
  color: ${WHITE};
  height: ${MOBILE_CELL_SIZE}px;
  justify-content: flex-end;
  overflow: hidden;

  ${media.tabletL`
    height: ${CELL_SIZE}px;
    padding: 3em;
  `};
`;
export const GridWrapperSectionJp = styled.section`
  background: ${WHITE};
`;
export const GridWrapperJp = styled.div`
  width: 750px;
  margin: 0 auto;
  display: none;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  justify-content: center;
  background: white !important;
  ${media.tabletL`
    display: grid;
  `};
`;
export const InstructorCellJp = styled.div`
  padding: 30px 10px;
  display: flex;
  flex-direction: column;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(${({ url }) => url});
  color: ${WHITE};
  width: 250px;
  height: 250px;
  /* height: ${MOBILE_CELL_SIZE}px; */
  justify-content: flex-end;
  overflow: hidden;

  ${media.tabletL`
    /* height: ${CELL_SIZE}px; */
    padding: 30px;
  `};
`;

export const MoreButtonWrap = styled.div`
  a {
    background-color: ${BLACK};
    border: none;
    color: ${WHITE};
    cursor: pointer;
    font-size: 14px;
    font-weight: 800;
    height: 72px;
    line-height: 72px;
    letter-spacing: 1px;
    margin: 40px auto 0;
    max-width: 340px;
    outline: none;
    align-items: center;
    display: flex;
    justify-content: center;

    ${media.tabletL`
      align-items: center;
      display: flex;
      justify-content: center;
    `};
  }
`;

export const Name = styled.p`
  margin: 0;
  text-transform: uppercase;
  font-size: 18px;
  letter-spacing: 1px;
  text-align: center;
`;

export const PlaceholderWrapper = styled.div`
  height: ${CELL_SIZE}px;
`;



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/Instructors/Instructors.style.js